import { useParams } from "react-router-dom";
import { EdbProvider } from "./form/context/EdbContext";
import EDBProfileContent from "./ProfileEDB/ProfileEDBContent";
import { ProfileEDBProvider } from "./ProfileEDB/context/ProfileEDBContext";

function EDBProfile() {
  const { idEdb } = useParams<"idEdb">();
  return (
    <EdbProvider>
      <ProfileEDBProvider idEdb={idEdb ?? null}>
        <EDBProfileContent />
      </ProfileEDBProvider>
    </EdbProvider>
  );
}

export default EDBProfile;
